import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { config } from '../../config';
@Injectable({
  providedIn: 'root'
})
export class MpService {

  practitioner: any = [];
  constructor(private http: HttpClient) {
    this.practitioner = [];
    console.log("Instructor Service initialized!!!!!!!", this.practitioner)
  }

  addPractitioner(data: any): Observable<any> {
    console.log("Adding practitioner", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "mp", data).subscribe((res: any) => {
        observer.next(res.data.mp);
      }, err => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    })
  }

  getPractitioners(): Observable<any> {
    console.log("Getting Practitioners");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "mp").subscribe((res: any) => {
        console.log("Get Practitioners : ", res);
        observer.next(res.data.mps);
        observer.complete();
      })
    });
  }

  getPractitionerById(id): Observable<any> {
    console.log("Getting Practitioner");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "mp?_id=" + id).subscribe((res: any) => {
        console.log("Get practitioner : ", res);
        observer.next(res.data.mps[0]);
        observer.complete();
      })
    });
  }

  editPractitioner(data: any): Observable<any> {
    console.log("Edit Practitioner", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.put(config.baseApiUrl + "mp", data).subscribe((res: any) => {
        console.log("Edited Practitioner : ", res);
        observer.next(res.data.instructor);
      }, err => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });
  }

  deletePractitioner(id) {
    return new Observable((observer) => {
      this.http.delete(config.baseApiUrl + "mp?_id=" + id).subscribe((res: any) => {
        observer.next(res.data.instructors);
        // observer.complete();
      }, err => {
        observer.error(err)
      }, () => {
        observer.complete();
      })

    })
  }
}
